export const ARRAY_FILE = [
  {
    label: 'Календарный учебный график (учебный план)',
    shortLabel: 'Учебный план',
    name: 'academic-calendar',
    required: true
  },
  {
    label: 'Приказ об утверждении председателя ГЭК',
    shortLabel: 'Приказ о председателе ГЭК',
    name: 'order-gek',
    required: false
  },
  {
    label: 'Приказ об утверждении состава ГЭК',
    shortLabel: 'Приказ о составе ГЭК',
    name: 'order-gek-structure',
    required: false
  },
  {
    label: 'Программа ГИА и лист ознакомления с ней обучающимися',
    shortLabel: 'Программа ГИА',
    name: 'gia-program-list',
    required: false
  },
  {
    label: 'Приказ о допуске обучающихся к ГИА',
    shortLabel: 'Приказ о допуске к ГИА',
    name: 'gia-admission',
    required: false
  },
  {
    label: 'План проведения ДЭ и лист ознакомления с ним',
    shortLabel: 'План ДЭ',
    name: 'de-plan-list',
    required: false
  }
]
